// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.react-resizable-handle {*/
/*    background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg width="16" height="16" viewBox="0 0 16 16" fill="%23333333" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath d="M8 0L6.59 1.41 12.17 7H0V9H12.17L6.59 14.59 8 16 16 8L8 0Z"/%3E%3C/svg%3E');*/
/*    background-position: bottom right;*/
/*    background-repeat: no-repeat;*/
/*    background-origin: content-box;*/
/*    box-sizing: border-box;*/
/*    cursor: se-resize;*/
/*    opacity: 0.7;*/
/*}*/

.react-resizable-handle-s {
    width: 100%;
    height: 10px;
    bottom: 0;
    left: 0;
    cursor: s-resize;
}

.react-resizable-handle-w {
    width: 10px;
    height: 100%;
    left: 0;
    top: 0;
    cursor: w-resize;
}

.react-resizable-handle-e {
    width: 10px;
    height: 100%;
    right: 0;
    top: 0;
    cursor: e-resize;
}

.react-resizable-handle-n {
    width: 100%;
    height: 10px;
    top: 0;
    left: 0;
    cursor: n-resize;
}

.react-resizable-handle-sw {
    width: 10px;
    height: 10px;
    bottom: 0;
    left: 0;
    cursor: sw-resize;
}

.react-resizable-handle-nw {
    width: 10px;
    height: 10px;
    top: 0;
    left: 0;
    cursor: nw-resize;
}

.react-resizable-handle-se {
    width: 10px;
    height: 10px;
    bottom: 0;
    right: 0;
    cursor: se-resize;
}

.react-resizable-handle-ne {
    width: 10px;
    height: 10px;
    top: 0;
    right: 0;
    cursor: ne-resize;
}

.react-resizable-handle:hover {
    opacity: 1;
}

.react-draggable:not(.react-resizable-hide) > div {
    padding: 10px;
    overflow: hidden;
    max-height: 95%;
    max-width: 100%;
}

.react-resizable-hide > div > .react-grid-dragHandle {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./src/lib/components/DashGridLayout.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B,8PAA8P;AAC9P,yCAAyC;AACzC,oCAAoC;AACpC,sCAAsC;AACtC,8BAA8B;AAC9B,yBAAyB;AACzB,oBAAoB;AACpB,IAAI;;AAEJ;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,OAAO;IACP,MAAM;IACN,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,MAAM;IACN,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,OAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,MAAM;IACN,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB","sourcesContent":["/*.react-resizable-handle {*/\n/*    background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"%23333333\" xmlns=\"http://www.w3.org/2000/svg\"%3E%3Cpath d=\"M8 0L6.59 1.41 12.17 7H0V9H12.17L6.59 14.59 8 16 16 8L8 0Z\"/%3E%3C/svg%3E');*/\n/*    background-position: bottom right;*/\n/*    background-repeat: no-repeat;*/\n/*    background-origin: content-box;*/\n/*    box-sizing: border-box;*/\n/*    cursor: se-resize;*/\n/*    opacity: 0.7;*/\n/*}*/\n\n.react-resizable-handle-s {\n    width: 100%;\n    height: 10px;\n    bottom: 0;\n    left: 0;\n    cursor: s-resize;\n}\n\n.react-resizable-handle-w {\n    width: 10px;\n    height: 100%;\n    left: 0;\n    top: 0;\n    cursor: w-resize;\n}\n\n.react-resizable-handle-e {\n    width: 10px;\n    height: 100%;\n    right: 0;\n    top: 0;\n    cursor: e-resize;\n}\n\n.react-resizable-handle-n {\n    width: 100%;\n    height: 10px;\n    top: 0;\n    left: 0;\n    cursor: n-resize;\n}\n\n.react-resizable-handle-sw {\n    width: 10px;\n    height: 10px;\n    bottom: 0;\n    left: 0;\n    cursor: sw-resize;\n}\n\n.react-resizable-handle-nw {\n    width: 10px;\n    height: 10px;\n    top: 0;\n    left: 0;\n    cursor: nw-resize;\n}\n\n.react-resizable-handle-se {\n    width: 10px;\n    height: 10px;\n    bottom: 0;\n    right: 0;\n    cursor: se-resize;\n}\n\n.react-resizable-handle-ne {\n    width: 10px;\n    height: 10px;\n    top: 0;\n    right: 0;\n    cursor: ne-resize;\n}\n\n.react-resizable-handle:hover {\n    opacity: 1;\n}\n\n.react-draggable:not(.react-resizable-hide) > div {\n    padding: 10px;\n    overflow: hidden;\n    max-height: 95%;\n    max-width: 100%;\n}\n\n.react-resizable-hide > div > .react-grid-dragHandle {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
